"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EnergyAuditPurpose() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const imageRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const {
        top
      } = imageRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (top < windowHeight && top > -imageRef.current.offsetHeight) {
        const parallaxValue = (windowHeight - top) * 0.05;
        setOffset(parallaxValue);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="a-quoi-sert-laudit-énergétique" className="bg-background overflow-hidden ![padding:96px_0px_96px_0px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div ref={textRef} className="flex flex-col gap-8 transition-all duration-1000 ease-out opacity-100 translate-y-0 !w-[1200px]">
            <h2 className="font-sans text-[40px] leading-tight font-bold text-primary !w-[1200px] !text-center">À quoi sert l’audit énergétique ?</h2>

            <div className="space-y-6 text-lg text-foreground/80 font-sans">
              <p className="!w-[1200px] !text-left">L’audit énergétique est bien plus qu’un simple diagnostic : c’est une véritable feuille de route pour la rénovation énergétique de votre maison.&nbsp; Dans un premier temps, il permet de réaliser un état des lieux approfondi de la performance énergétique et environnementale de votre logement. Fort de ce diagnostic, il vise ensuite à orienter le propriétaire (ou le futur propriétaire) en lui faisant des propositions de travaux chiffrées permettant de réduire les consommations énergétiques, d'améliorer le confort et la qualité de l'air tout en optimisant le coût des travaux.&nbsp;</p>
              <p className="!w-[1200px]">Si vous souhaitez vendre votre maison dite "passoire énergétique", c'est à dire clasée E, F ou G, l'audit énergétique est OBLIGATOIRE.&nbsp;<br />Si vous souhaitez obtenir des aides pour financer vos travaux de rénovation énergétique (MaPrimeRénov', CEE, Eco-PTZ...) l'audit énergétique est INDISPENSABLE.</p>
            </div>

            <div className="grid gap-4 !w-[900px] ![margin:0px_0px_0px_180px] sm:grid-cols-2">
              {["Réduction des consommations énergétiques", "Obtention des aides", "Amélioration du confort", "Conformité réglementaire", "Optimisation du budget travaux", "Valorisation du patrimoine"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-secondary shrink-0" />
                  <span className="text-base font-medium text-foreground">
                    {item}
                  </span>
                  {i === 1 && <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/image_kmdu3ulq.jpg" alt="" className="w-[60px] h-[34px] object-contain" />}
                  {i === 1 && <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/image_xasppaj4.jpg" alt="" className="w-[60px] h-[34px] object-contain" />}
                  {i === 1 && <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/image_leuv9s8w.jpg" alt="" className="w-[60px] h-[34px] object-contain" />}
                </div>)}
            </div>

            
          </div>
        </div>
      </div>
    </section>;
}